import { getMergedAdData } from 'components/advert/utils/ad-targeting-merge';
import { shouldDisplayWithHideWhen } from 'layout/utils-hide-when';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context';
import { useContext } from 'react';
import { useAppSelector } from 'redux-state/configure-store';
import { getWindow } from 'utilities/window';
import { AdvertComponent } from './advert-component';
import { AdvertErrorBoundary } from './advert-error-boundary';

export const AdvertMapStatic = () => {
  const adSize = useContext(ScreenSizeContext);
  const { adDefinitions, targeting, account: ac, mapTakeover } = useAppSelector((state) => state.ADVERTISEMENT);
  const screenSize = useContext(ScreenSizeContext);

  const adDisplayFalseCB = () => {
    getWindow()?.AdUtils.clearMapTakeover();
  };

  const mapTakeoverData = getMergedAdData({
    ad: mapTakeover,
    defs: adDefinitions,
    adSize,
  });

  if (ac && mapTakeoverData && shouldDisplayWithHideWhen(mapTakeover, screenSize)) {
    return (
      <div className="Map-sponsorship" style={{ width: '100%', height: '100%' }}>
        <AdvertErrorBoundary>
          <AdvertComponent
            {...mapTakeoverData}
            targeting={targeting}
            key={screenSize}
            ac={ac}
            origin="map-takeover"
            adDisplayFalseCB={adDisplayFalseCB}
          />
        </AdvertErrorBoundary>
      </div>
    );
  }

  return null;
};
